export const fonts = {
  heading: "InterVariable, sans-serif",
  body: "InterVariable, sans-serif",
};
